/**
 * 작업 지시서 관련 상수 정의
 */

// 단계 정보
export const STEPS = [
  { id: 0, name: '거래처 선택', description: '인증서를 전달할 거래처를 선택합니다.' },
  { id: 1, name: '환자 정보 입력', description: '환자의 기본 정보를 입력합니다.' },
  { id: 2, name: '상세 정보 입력', description: '보철의 상세 정보를 입력합니다.' },
  { id: 3, name: '정보 전달', description: '입력한 정보를 최종 확인하고 전달합니다.' }
];

// 진행 상태 텍스트
export const PROGRESS_TEXTS = [
  '거래처 선택',
  '환자 정보 입력', 
  '상세 정보 입력',
  '정보 전달'
];

// 수술 타입
export const SURGERY_TYPES = {
  CROWN: 'CROWN',
  IMPLANT_CROWN: 'IMPLANT_CROWN',
  BRIDGE: 'BRIDGE',
  INLAY: 'INLAY',
  LAMINATE: 'LAMINATE'
};

// 수술 타입 라벨
export const SURGERY_TYPE_LABELS = {
  [SURGERY_TYPES.CROWN]: '크라운',
  [SURGERY_TYPES.IMPLANT_CROWN]: '임플란트 크라운',
  [SURGERY_TYPES.BRIDGE]: '브릿지',
  [SURGERY_TYPES.INLAY]: '인레이',
  [SURGERY_TYPES.LAMINATE]: '라미네이트'
};

// 성별 매핑
export const GENDER_MAP = {
  male: '남성',
  female: '여성',
  unknown: '모름',
  '': '입력 안 함'
};

// 국가 코드
export const COUNTRY_CODES = [
  { value: '+82', label: '+82 (한국)' },
  { value: '+86', label: '+86 (중국)' },
  { value: '+1', label: '+1 (미국)' }
];

// 전송 채널
export const SEND_CHANNELS = {
  KAKAOTALK: 'KAKAOTALK',
  WECHAT: 'WECHAT', 
  EMAIL: 'EMAIL'
};

// 언어 코드
export const LANGUAGES = {
  KO: 'ko',
  ZH: 'zh',
  EN: 'en'
};

// 덴탈맥스 제품 목록
export const DENTALMAX_PRODUCTS = [
  'LUXEN 5G ML',
  'LUXEN 5G Smile',
  'LUXEN 1200+600 Multi',
  'LUXEN 1100 Multi',
  'LUXEN 1100 Enamel',
  'LUXEN 1200 Zr'
];

// API 엔드포인트
export const API_ENDPOINTS = {
  MANUFACTURERS: '/accounts/issue/manufacturers/DENT/ZIRCONIA',
  WORK_ORDERS: '/dental-laboratory/work-orders'
};

// 기본 제조사 데이터
export const DEFAULT_MANUFACTURER = {
  name: "덴탈맥스",
  engName: "dentalmax",
  iconUrl: "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round/Zirconia.svg",
  imgUrl: "https://certilife.blob.core.windows.net/certilife/202508/file_1754983383092.png",
  colorCode: "#C2E3E3",
  nftTitle: "지르코니아 정품 인증서",
  klipCompanyName: "덴탈맥스(Dentalmax)",
  objectIdKey: "DENTALMAX_OBJECT_ID",
  description: "본 카드는 덴탈맥스의 지르코니아 시스템을 정식으로 공급 받아 사용하였음을 인증합니다.",
  displayOrder: 11,
  customFields: {
    itemName: ""
  },
  isCertified: true,
  medicalDept: "DENT",
  productType: "ZIRCONIA",
  deleteYn: "N",
  iconUrlBackup: "https://objectstorage.kr-central-1.kakaocloud.com/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round/Zirconia.svg",
  imgUrlBackup: "https://objectstorage.kr-central-1.kakaocloud.com/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card/DENT/zirconia.png",
  iconUrlNew: "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_round/Zirconia.svg",
  imgUrlNew: "https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card/DENT/zirconia.png"
};
